/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import {
  NG_ENTITY_SERVICE_CONFIG
} from '@datorama/akita-ng-entity-service';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MomentModule } from 'angular2-moment';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { tap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { ServiceCentersService } from './@core/akita-stores/entity-stores/sercice-centers/service-centers.service';
import { saveTimezone } from './@core/akita-stores/storage';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AppHttpInterceptor } from './interceptors/http.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMatDateAdapter, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    environment.production ? [AkitaNgRouterStoreModule.forRoot()] : [AkitaNgDevtools.forRoot(), AkitaNgRouterStoreModule.forRoot()],
    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NgxPermissionsModule.forRoot(),
    CoreModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    MomentModule,
    ScrollingModule,
    LazyLoadImageModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: getToken
      }
    }),
    NgxDatatableModule,
    NgxPaginationModule,
    NgxMatDatetimePickerModule,
    NgxMatMomentModule,
    DeviceDetectorModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true,
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initApp,
    //   multi: true,
    //   deps: [ServiceCentersService]
    // },
    {
      provide: NG_ENTITY_SERVICE_CONFIG,
      useValue: {
        baseUrl: environment.baseAPI,
      },
    },
    CurrencyPipe,
    DecimalPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

export function getToken() {
  if (localStorage.getItem('session')) {
    return JSON.parse(localStorage.getItem('session')).accessToken;
  }
  return '';
}

// export function initApp(service: ServiceCentersService) {
//   return () => new Promise<any>((resolve, reject) => {
//     console.log('test: 1')
//     service.getServiceCenters(false).pipe(
//       tap((centres: any) => {
//         let timezone = environment.defaultTimezone;
//         if (centres && centres[0] && centres[0].addresses && centres[0].addresses[0].address.others.timezone) {
//           timezone = centres[0].addresses[0].address.others.timezone;
//         }
//         saveTimezone(timezone);
//       })
//     ).subscribe(resolve, reject);
//   });
// }

// export function initServiceCenters(service: ServiceCentersService) {
//   console.log('test: 2')
//   return () => new Promise<any>((resolve, reject) => {
//     service.getServiceCenters().subscribe(resolve, reject);
//   });
// }
